
//Временная линия задач, используется для вывода задач в течении скуток

import {BreakException, Collection} from "./Main";
import {TaskInterface} from "./Task";

export class TimeLine {

    private taskCollection: Collection<TimeLineTask>;
    private taskTimeLag:number = 5;

    constructor(tasks: Collection<TaskInterface>, private slots: TimeSlot[] = [] ){
        this.taskCollection = new Collection<TimeLineTask>();
        tasks.getItems().forEach((item) => {
            this.taskCollection.addItem(new TimeLineTask(item));
        });
        this.initSlots();
        this.initTasksTime();
        this.initCross();
    }

    public getTasks(){
        return this.taskCollection;
    }

    private tasks(): Collection<TimeLineTask>{
        return this.taskCollection;
    }

    private initSlots(){
        /***
         * Метод который инициализирует занятые слоты для задач у которых указано время
         *
         */
        this.tasks().getItems().forEach((task)=> {
            if(task.getTask().hasDueTime()) {
                this.slots.push( new TimeSlot({start: task.startAt(),end: task.endAt()}));
            }
        });
        this.slots = (new TimeSlots(this.slots)).combineSlots().getSlots();


    }

    private initTasksTime(){
        /**
         * Метод который инициализирует слоты и старты для задач
         * которые не имеют времени начала
         */
        let tasks = this.tasks();
        let slots = this.slots;

        tasks.getItems().forEach((task) => {
            if (task.getTask().hasDueTime()){
                return null;
            }
            try {
                slots.forEach((slot, index) => {
                    if (!((index + 1) in slots)) {
                        return task.setStartAt(slot.end());
                    }
                    if (task.height()+this.taskTimeLag <= (slots[index + 1].start() - slot.end())) {
                        task.setStartAt(slot.end()+this.taskTimeLag);
                        slots.push(new TimeSlot({start: task.startAt(), end: task.endAt()}));
                        slots = (new TimeSlots(slots)).combineSlots().getSlots();
                        throw new BreakException();
                    }
                })
            }catch (e) {

                if (!(e instanceof BreakException)) throw e;
            }

        });
        console.log(slots);
    }

    private initCross(){
        //   Найти пересечение по задачам и задать сколько задач пересекается, точбы процент высчитать

        let tasks = this.tasks();
        tasks.getItems().forEach((itask) => {

            let count = 0;
            itask.startAt();

            tasks.getItems().forEach((itaskInner) => {



                // Если есть перемеченеи с задачей но ставим персечение
                if(
                    (itask.startAt() <= itaskInner.startAt() && itaskInner.startAt() < itask.endAt())
                    || (itask.startAt() < itaskInner.endAt() && itaskInner.endAt() <= itask.endAt())

                ) {

                     itask.getCrossing().addItem(itaskInner);



                }


            });




        });
    }

}


export class TimeLineTask {

    private start: number;
    private end: number;
    private crossing: CrossTask;

    constructor(private readonly task: TaskInterface){
        this.crossing =  new CrossTask(this)
    }

    getTask(){
        return this.task;
    }

    setStartAt(start: number): number{
        return this.start = start;
    }


    startAt(){
        return this.start || this.getMinutesAfterMidnight();
    }

    endAt(){
        return this.startAt()+this.height();
    }
    height(){

        let toMinute = this.getTask().time().toMinute();
        if (toMinute < 15) {
            return 15;
        }
        return  toMinute;

    }
    getCrossing(): CrossTask{
        return this.crossing;
    }

    getCrossingCount(){
        if(!this.getCrossing() || this.getCrossing().getCount() == 0 ){
            return  1;
        }
        return this.getCrossing().getItems().reduce(function (maxValue, itemB) {
            let countB = itemB.getCrossing().getCount();
            return ( maxValue < countB ? countB : maxValue );

        },  0);
        return this.getCrossing().getCount();


    }
    getWidth(){
        return 100/(this.getCrossingCount());
    }

    getMarginLEft(){

        let index = this.getCrossing().getItems().findIndex( (elemetn) => {
            return elemetn == this;
        });
        if(index == -1){
            return 0;
        }
        return index*100/this.getCrossingCount();

    }

    private getMinutesAfterMidnight(){
        return this.task.getDueDate().getHours()*60+this.task.getDueDate().getMinutes()
    }


}



export class TimeSlot {

    constructor(private props: {start: number, end:number, name?: string}){

    }

    start(){
        return this.props.start;
    }
    end(){
        return this.props.end;
    }
    setEnd(end:number){
        return this.props.end = end;
    }
    name(){
        return this.props.name;
    }
}


export class TimeSlots {

    constructor(private slots: TimeSlot[]){

    }
    getSlots(){
        return this.slots;
    }

    combineSlots(): TimeSlots{
        let slots = [...this.slots];

        slots.sort((slotA: TimeSlot, slotB: TimeSlot) => slotA.start() > slotB.start() ? 1 : -1);

        let intervals:TimeSlot[] = [];

        slots.forEach(function (slotA, indexA) {
            slots.forEach(function (slotB, indexB) {
                if ( indexB == indexA) return;

                if(slotA.end() >= slotB.end() && slotA.start() <= slotB.start()){
                    delete (slots[indexB]);
                }
            });

            slots.forEach(function (slotB, indexB) {
                if ( indexB == indexA) return;
                if(slotA.end() >= slotB.start() && slotA.end() <= slotB.end()){

                    slots[indexA].setEnd(slotB.end());
                    delete(slots[indexB]);
                }
            });

            intervals.push(slotA);
        });

        return new TimeSlots(intervals);
    }

}




class CrossTask {
    private items: TimeLineTask[] = [];

    constructor(private mainTask: TimeLineTask){
        this.items.push(mainTask);
    }

    getCount(){
        return this.items.length;
    }

    addItem(item: TimeLineTask){
        if(this.items.indexOf(item) == -1)  {
            this.items.push(item);
            item.getCrossing().addItem(this.mainTask)
        }
    }

    getItems(){
        let items =  this.items.sort((itemA, itemB) => {
                //itemB.getCrossing().getCount() < itemA.getCrossing().getCount()  &&
                if (itemB.startAt() == itemA.startAt()) {
                    return  itemB.getTask().getId() > itemA.getTask().getId() ? -1 : 1;
                }
                return itemB.startAt() > itemA.startAt() ? -1 : 1
            }

        );
        return items;
        return this.items.sort((itemA, itemB) => itemB.getTask().getId() > itemA.getTask().getId() ? -1 : 1);
    }
}